<script>
  import router from './router'
  import api from '@/api'

  export default {
    name: 'App',
    router,
    data: () => ({
      state: {
        agencies: [],
        availability: []
      },
      error: '',
      loading: true
    }),
    created() {
      this.getStart()
    },
    methods: {
      async getStart() {
        try {
          this.loading = true
          this.state.agencies = await api.getStart()
        } catch (error) {
          console.error(error)
        } finally {
          this.loading = false
        }
      },
      async getAvailability() {
        try {
          this.loading = true
          this.state.availability = await api.getAvailability()
        } catch (error) {
          console.error(error)
        } finally {
          this.loading = false
        }
      },
      async createAppointment(payload) {
        try {
          const res = await api.postAppointment(payload)
          await this.$router.push({
            name: 'Success',
            query: {
              confirm: res.confirmation_link,
              dateTime: payload.datetime
            }
          })
        } catch (e) {
          this.error = e.response.data.reason
        }
      }
    }
  }
</script>

<template>
  <div id="app">
    <router-view
      :state="state"
      :error="error"
      @get-availability="getAvailability"
      @submit="createAppointment"
    />
  </div>
</template>

<style lang="scss">
  @import 'theme';
  @import '~bootstrap/scss/bootstrap';

  #app {
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    text-align: center;
    margin-bottom: 2rem;
  }
</style>
